export default __webpack_public_path__ + "static/media/918.f6f64cb5.gif";